module.exports = __webpack_public_path__ + "assets/9841290e1721f8dc0403efc65a1d4172.woff";